import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API } from '../../../api/services';
export const fetchDashboardDetails: any = createAsyncThunk('dashboardDetails/fetchDashboardDetails', async (channelId: any) => {
   
  try {
     console.log(":::::::::::::::")
      const response = await API.post(`/dashboard`, channelId, {
          headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
          }
      },);
          console.log('response--------: ', response);
  
      console.log('response: ', response?.data);
      return response?.data;
  } catch (error) {
    console.log("🚀 ~ error:", error)
    
  }

});

const initialState = {
    dashboardData: {},
};

const dashboardSlice = createSlice({
    name: 'dashboardDetails',
    initialState,
    reducers: {
        setDashboardState: (state, { payload }) => {
            state.dashboardData = payload;
        },
    },

});

export const { setDashboardState } = dashboardSlice.actions;
export default dashboardSlice.reducer;



